export const paddings = {
  smallest: 9,
  extraSmall: 16,
  small: 20,
  medium: 24,
  large: 32,
  extraLarge: 40,
  largest: 48,
}
